module.exports = __webpack_public_path__ + "static/media/deleteRowOrganizations.a8038fc3.svg";